import { render, staticRenderFns } from "./process_route_edit.vue?vue&type=template&id=36673c7e&scoped=true"
import script from "./process_route_edit.vue?vue&type=script&lang=js"
export * from "./process_route_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36673c7e",
  null
  
)

export default component.exports